import React from "react";
import { Result, Button } from "antd";
import config from "../config";

export default function RouteMigrated() {
  return (
    <Result
      status="info"
      title="This route is no longer available."
      subTitle={
        <span style={{ fontSize: 18 }}>
          {`This functionality has been migrated to our new application. Please update your bookmarks and continue here: ${config.ADMINV3_URL}`}
        </span>
      }
      extra={
        <Button type="primary" href={config.ADMINV3_URL}>
          Go to new application
        </Button>
      }
    />
  );
}
